import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {AUTH0_ROLE, UserProfile} from '../shared/types/UserProfile';

@Injectable({
  providedIn: 'root'
})

export class AuthorizationService {

  constructor() {
  }

  private _userProfile = new BehaviorSubject<UserProfile>({
    id: '', email: '', firstName: '', lastName: '', role: AUTH0_ROLE.NONE, account: '', trialDaysLeft: null
  });
  private _permissions = new BehaviorSubject<string[]>([]);
  public userProfile$ = this._userProfile.asObservable();
  public permissions$ = this._permissions.asObservable();

  get userProfile(): UserProfile {
    return this._userProfile.getValue();
  }

  set userProfile(profile: Partial<UserProfile>) {
    this._userProfile.next({...this.userProfile, ...profile});
  }

  get profileInitiated(): boolean {
    return Boolean(this.userProfile.email || this.userProfile.firstName);
  }

  set permissions(permissions: string[]) {
    this._permissions.next(permissions);
  }

  resetProfile() {
    this.userProfile = {id: '', email: '', firstName: '', lastName: '', role: AUTH0_ROLE.NONE, account: ''};
  }

  hasPermissions(permissions: string[]): boolean {
    return permissions.every(p => this._permissions.getValue().includes(p));
  }

  get isAdminUser(): boolean {
    return this.userProfile.role === AUTH0_ROLE.ADMIN;
  }

  get isTrialUser(): boolean {
    return this.userProfile.role === AUTH0_ROLE.TRIAL;
  }

  get isExpiredUser(): boolean {
    return this.userProfile.role === AUTH0_ROLE.EXPIRED;
  }
}
